export default "__VITE_ASSET__mB4Vx7yE__"